/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 6BCq4vMow1yqGKFdcP68Rz
// Component: jTLog2H3DE

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  generateStateOnChangeProp,
  generateStateValueProp,
  renderPlasmicSlot,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import Switch from "../../components/Switch"; // plasmic-import: ntKkcfMNg2s/component
import Select from "../../components/widgets/Select"; // plasmic-import: j_4IQyOWK2b/component
import Textbox from "../../components/widgets/Textbox"; // plasmic-import: pA22NEzDCsn_/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 6BCq4vMow1yqGKFdcP68Rz/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_plasmic_kit_page_settings.module.css"; // plasmic-import: 6BCq4vMow1yqGKFdcP68Rz/projectcss
import sty from "./PlasmicPageSettings.module.css"; // plasmic-import: jTLog2H3DE/css

import CloseSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__CloseSvg"; // plasmic-import: DhvEHyCHT/icon
import SearchSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__SearchSvg"; // plasmic-import: R5DLz11OA/icon

createPlasmicElementProxy;

export type PlasmicPageSettings__VariantMembers = {};
export type PlasmicPageSettings__VariantsArgs = {};
type VariantPropType = keyof PlasmicPageSettings__VariantsArgs;
export const PlasmicPageSettings__VariantProps = new Array<VariantPropType>();

export type PlasmicPageSettings__ArgsType = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  canonical?: React.ReactNode;
};
type ArgPropType = keyof PlasmicPageSettings__ArgsType;
export const PlasmicPageSettings__ArgProps = new Array<ArgPropType>(
  "title",
  "description",
  "canonical"
);

export type PlasmicPageSettings__OverridesType = {
  root?: Flex__<"div">;
  routeInput?: Flex__<typeof Textbox>;
  characterCount?: Flex__<"div">;
  imageAssetPicker?: Flex__<"div">;
  propsControl?: Flex__<"div">;
  renderModeLabel?: Flex__<"div">;
  renderModeSelect?: Flex__<typeof Select>;
  loginRequiredRow?: Flex__<"div">;
  loginRequiredLabel?: Flex__<"div">;
  loginRequiredSwitch?: Flex__<typeof Switch>;
  roleRequiredRow?: Flex__<"div">;
  roleRequiredLabel?: Flex__<"div">;
  roleRequiredSelect?: Flex__<typeof Select>;
};

export interface DefaultPageSettingsProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  canonical?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicPageSettings__RenderFunc(props: {
  variants: PlasmicPageSettings__VariantsArgs;
  args: PlasmicPageSettings__ArgsType;
  overrides: PlasmicPageSettings__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "loginRequiredSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
      },
      {
        path: "renderModeSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
      },
      {
        path: "roleRequiredSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__f5CjA)}>
        <div className={classNames(projectcss.all, sty.freeBox__jBw6C)}>
          <div className={classNames(projectcss.all, sty.freeBox__oAobL)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__byQuB
              )}
            >
              {"URL Path"}
            </div>
          </div>
          <Textbox
            data-plasmic-name={"routeInput"}
            data-plasmic-override={overrides.routeInput}
            className={classNames("__wab_instance", sty.routeInput)}
            placeholder={"/some-route"}
            prefixIcon={
              <SearchSvgIcon
                className={classNames(projectcss.all, sty.svg__sXrs1)}
                role={"img"}
              />
            }
            styleType={["bordered"]}
            suffixIcon={
              <CloseSvgIcon
                className={classNames(projectcss.all, sty.svg__t5Rk5)}
                role={"img"}
              />
            }
          />
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__ucQAw)}>
          {renderPlasmicSlot({
            defaultContents: (
              <React.Fragment>
                <div className={classNames(projectcss.all, sty.freeBox__w0OV)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__sM34
                    )}
                  >
                    {"Title"}
                  </div>
                </div>
                <Textbox
                  className={classNames("__wab_instance", sty.textbox__mY5Mi)}
                  placeholder={"My fancy page"}
                  prefixIcon={
                    <SearchSvgIcon
                      className={classNames(projectcss.all, sty.svg__xOaFz)}
                      role={"img"}
                    />
                  }
                  styleType={["bordered"]}
                  suffixIcon={
                    <CloseSvgIcon
                      className={classNames(projectcss.all, sty.svg__uZzrb)}
                      role={"img"}
                    />
                  }
                />
              </React.Fragment>
            ),
            value: args.title,
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__zOpQb)}>
          <div className={classNames(projectcss.all, sty.freeBox__wdnNw)}>
            {renderPlasmicSlot({
              defaultContents: (
                <React.Fragment>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__lGjqj)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__oSXc
                      )}
                    >
                      {"Description"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__rmMyq)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__j0Jrg)}
                    >
                      <textarea
                        className={classNames(
                          projectcss.all,
                          projectcss.textarea,
                          sty.textarea___40UOz
                        )}
                        placeholder={
                          "A description to show for search engine results."
                        }
                      />
                    </div>
                  </div>
                </React.Fragment>
              ),
              value: args.description,
            })}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__uFy4)}>
            <div className={classNames(projectcss.all, sty.freeBox__aYaBf)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__nf6Kg
                )}
              >
                {"Character count:"}
              </div>
              <div
                data-plasmic-name={"characterCount"}
                data-plasmic-override={overrides.characterCount}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.characterCount
                )}
              >
                {"XX"}
              </div>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__v5Bs7
              )}
            >
              {"(Recommended: 160)"}
            </div>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__hurYr)}>
          {renderPlasmicSlot({
            defaultContents: (
              <React.Fragment>
                <div className={classNames(projectcss.all, sty.freeBox__xodgj)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__nGAv
                    )}
                  >
                    {"Canonical URL"}
                  </div>
                </div>
                <Textbox
                  className={classNames("__wab_instance", sty.textbox__eoxLf)}
                  placeholder={"https://canonical.url"}
                  prefixIcon={
                    <SearchSvgIcon
                      className={classNames(projectcss.all, sty.svg__w2Vyd)}
                      role={"img"}
                    />
                  }
                  styleType={["bordered"]}
                  suffixIcon={
                    <CloseSvgIcon
                      className={classNames(projectcss.all, sty.svg__xc8TJ)}
                      role={"img"}
                    />
                  }
                />
              </React.Fragment>
            ),
            value: args.canonical,
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__zwdd8)}>
          <div className={classNames(projectcss.all, sty.freeBox__elLZ)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__eyrOx
              )}
            >
              {"Open Graph image"}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__v3EQ
              )}
            >
              {"The preview image when the page is shared on social media."}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__bmaVn)}>
            <div
              data-plasmic-name={"imageAssetPicker"}
              data-plasmic-override={overrides.imageAssetPicker}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.imageAssetPicker
              )}
            >
              {"This is the image asset picker"}
            </div>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__pd0)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__rAUsl
            )}
          >
            {"More metadata"}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__zwogK)} />
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__r3Es1)}>
          <div className={classNames(projectcss.all, sty.freeBox__gq12T)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__nXsp
              )}
            >
              {""}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__nlHjo)}>
            <div
              data-plasmic-name={"propsControl"}
              data-plasmic-override={overrides.propsControl}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.propsControl
              )}
            >
              {"Props control"}
            </div>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__cMjM)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__a8Wj
            )}
          >
            {"Advanced"}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__ykmFj)} />
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__wm2MJ)}>
          <div
            data-plasmic-name={"renderModeLabel"}
            data-plasmic-override={overrides.renderModeLabel}
            className={classNames(projectcss.all, sty.renderModeLabel)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__y4M9G
              )}
            >
              {"Render mode"}
            </div>
          </div>
          <Select
            data-plasmic-name={"renderModeSelect"}
            data-plasmic-override={overrides.renderModeSelect}
            className={classNames("__wab_instance", sty.renderModeSelect)}
            onChange={async (...eventArgs: any) => {
              ((...eventArgs) => {
                generateStateOnChangeProp($state, [
                  "renderModeSelect",
                  "value",
                ])(eventArgs[0]);
              }).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            value={generateStateValueProp($state, [
              "renderModeSelect",
              "value",
            ])}
          />
        </div>
        <div
          data-plasmic-name={"loginRequiredRow"}
          data-plasmic-override={overrides.loginRequiredRow}
          className={classNames(projectcss.all, sty.loginRequiredRow)}
        >
          <div
            data-plasmic-name={"loginRequiredLabel"}
            data-plasmic-override={overrides.loginRequiredLabel}
            className={classNames(projectcss.all, sty.loginRequiredLabel)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__fdmLq
              )}
            >
              {"Login needed"}
            </div>
          </div>
          <Switch
            data-plasmic-name={"loginRequiredSwitch"}
            data-plasmic-override={overrides.loginRequiredSwitch}
            className={classNames("__wab_instance", sty.loginRequiredSwitch)}
            isChecked={
              generateStateValueProp($state, [
                "loginRequiredSwitch",
                "isChecked",
              ]) ?? false
            }
            onChange={async (...eventArgs: any) => {
              ((...eventArgs) => {
                generateStateOnChangeProp($state, [
                  "loginRequiredSwitch",
                  "isChecked",
                ])(eventArgs[0]);
              }).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
          >
            {""}
          </Switch>
        </div>
        <div
          data-plasmic-name={"roleRequiredRow"}
          data-plasmic-override={overrides.roleRequiredRow}
          className={classNames(projectcss.all, sty.roleRequiredRow)}
        >
          <div
            data-plasmic-name={"roleRequiredLabel"}
            data-plasmic-override={overrides.roleRequiredLabel}
            className={classNames(projectcss.all, sty.roleRequiredLabel)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__yxT2J
              )}
            >
              {"Role needed"}
            </div>
          </div>
          <Select
            data-plasmic-name={"roleRequiredSelect"}
            data-plasmic-override={overrides.roleRequiredSelect}
            className={classNames("__wab_instance", sty.roleRequiredSelect)}
            onChange={async (...eventArgs: any) => {
              ((...eventArgs) => {
                generateStateOnChangeProp($state, [
                  "roleRequiredSelect",
                  "value",
                ])(eventArgs[0]);
              }).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            value={generateStateValueProp($state, [
              "roleRequiredSelect",
              "value",
            ])}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "routeInput",
    "characterCount",
    "imageAssetPicker",
    "propsControl",
    "renderModeLabel",
    "renderModeSelect",
    "loginRequiredRow",
    "loginRequiredLabel",
    "loginRequiredSwitch",
    "roleRequiredRow",
    "roleRequiredLabel",
    "roleRequiredSelect",
  ],
  routeInput: ["routeInput"],
  characterCount: ["characterCount"],
  imageAssetPicker: ["imageAssetPicker"],
  propsControl: ["propsControl"],
  renderModeLabel: ["renderModeLabel"],
  renderModeSelect: ["renderModeSelect"],
  loginRequiredRow: [
    "loginRequiredRow",
    "loginRequiredLabel",
    "loginRequiredSwitch",
  ],
  loginRequiredLabel: ["loginRequiredLabel"],
  loginRequiredSwitch: ["loginRequiredSwitch"],
  roleRequiredRow: [
    "roleRequiredRow",
    "roleRequiredLabel",
    "roleRequiredSelect",
  ],
  roleRequiredLabel: ["roleRequiredLabel"],
  roleRequiredSelect: ["roleRequiredSelect"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  routeInput: typeof Textbox;
  characterCount: "div";
  imageAssetPicker: "div";
  propsControl: "div";
  renderModeLabel: "div";
  renderModeSelect: typeof Select;
  loginRequiredRow: "div";
  loginRequiredLabel: "div";
  loginRequiredSwitch: typeof Switch;
  roleRequiredRow: "div";
  roleRequiredLabel: "div";
  roleRequiredSelect: typeof Select;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPageSettings__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPageSettings__VariantsArgs;
    args?: PlasmicPageSettings__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicPageSettings__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPageSettings__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPageSettings__ArgProps,
          internalVariantPropNames: PlasmicPageSettings__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPageSettings__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPageSettings";
  } else {
    func.displayName = `PlasmicPageSettings.${nodeName}`;
  }
  return func;
}

export const PlasmicPageSettings = Object.assign(
  // Top-level PlasmicPageSettings renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    routeInput: makeNodeComponent("routeInput"),
    characterCount: makeNodeComponent("characterCount"),
    imageAssetPicker: makeNodeComponent("imageAssetPicker"),
    propsControl: makeNodeComponent("propsControl"),
    renderModeLabel: makeNodeComponent("renderModeLabel"),
    renderModeSelect: makeNodeComponent("renderModeSelect"),
    loginRequiredRow: makeNodeComponent("loginRequiredRow"),
    loginRequiredLabel: makeNodeComponent("loginRequiredLabel"),
    loginRequiredSwitch: makeNodeComponent("loginRequiredSwitch"),
    roleRequiredRow: makeNodeComponent("roleRequiredRow"),
    roleRequiredLabel: makeNodeComponent("roleRequiredLabel"),
    roleRequiredSelect: makeNodeComponent("roleRequiredSelect"),

    // Metadata about props expected for PlasmicPageSettings
    internalVariantProps: PlasmicPageSettings__VariantProps,
    internalArgProps: PlasmicPageSettings__ArgProps,
  }
);

export default PlasmicPageSettings;
/* prettier-ignore-end */
